/*
 * @Author: ken yang
 * @Date: 2026-04-27
 * @LastEditTime: 2026-04-27
 * @LastEditors: ken yang
 * @Description: IPO 活动相关接口
 * @FilePath: /uexch_pc/src/api/ipo.js
 */
import { useReq } from '@/utils/request/useReq'

// IPO 首页列表 (POST /activity/ipo/homepage/list)
const listUrl = '/activity/ipo/homepage/list'
const list = (params = {}, options = {}) =>
  useReq(listUrl, { method: 'POST', data: params, auth: false }, options)

// IPO 项目详情 (POST /activity/ipo/homepage/detail)
const detailUrl = '/activity/ipo/homepage/detail'
const detail = (params = {}, options = {}) =>
  useReq(detailUrl, { method: 'POST', data: params, auth: false }, options)

// IPO 认购提交 (POST /activity/ipo/subscribe)
const subscribeUrl = '/activity/ipo/subscribe'
const subscribe = (params = {}, options = {}) =>
  useReq(subscribeUrl, { method: 'POST', data: params }, { immediate: false, ...options })

// 我的 IPO 认购记录 (POST /activity/ipo/subscription/my)
const mySubscriptionsUrl = '/activity/ipo/subscription/my'
const mySubscriptions = (params = {}, options = {}) =>
  useReq(mySubscriptionsUrl, { method: 'POST', data: params }, options)

// IPO 融资待缴款确认 (POST /activity/ipo/subscription/confirmPayment)
const confirmPaymentUrl = '/activity/ipo/subscription/confirmPayment'
const confirmPayment = (params = {}, options = {}) =>
  useReq(confirmPaymentUrl, { method: 'POST', data: params }, { immediate: false, ...options })

const needLoginUrl = [subscribeUrl, mySubscriptionsUrl, confirmPaymentUrl]

export const ipoApi = {
  list,
  detail,
  subscribe,
  mySubscriptions,
  confirmPayment,
  needLoginUrl,
}

export default ipoApi
